<template lang="pug">
.pl-4.pr-4
  .d-flex.align-center
    .top-fields
      v-btn(small color='primary' 
        @click="checkReservationQueueHandler" 
        :disabled="disabledReservationQueue" 
        outlined
      ).top-fields__item Try to reserve
      v-btn(small color='primary'
        @click="$emit('parseReserveNumber', model.ID)"
        :disabled="disabledParseNumberButton"
        outlined
      ).top-fields__item Parse Reservation Number
      accept-test(:activeItems="[model]").top-fields__item
      mark-as-processed(:model="model" :disabled="disabledMarkAsProcessed").top-fields__item
      wait-list-btn(:isWaitList.sync="model.isWaitList" v-show="isPageWithShowingWaitListBtn" :ID="model.ID").top-fields__item
      set-mijn(
        :ID="model.ID" 
        v-if="canShowMijn" 
        :defaultCourse="model.course"
        :status="model.status"
      ).top-fields__item
      removeMIJN(:ID="model.ID" v-if="model.isMijnReservation").top-fields__item
      labels(:value="model.labels" hide-exclude @changed="updateLabels" v-if="showLabels").top-fields__item
        template(v-slot:activator="{on}")
          v-btn(color="primary" small v-on="on" outlined data-test="c-label-btn")  Assign labels
      candidateArchive(:ID="model.ID" :disabled="model.disabledDelete").top-fields__item
      sync(:activeItems="[model]").top-fields__item
      add-to-landing(:ID="model.ID" :disabled="disabledAddToLanding").top-fields__item

  v-row.item-container.pt-3
    v-col(cols=6)
      h3.form-title.pb-4 Information
      .d-flex.align-center
        v-text-field(label="Candidate number" 
          disabled 
          :value="model.candidateNumber" 
          @input="candidateNumberUpdating"
          type="number" 
          name="candidatenumber"
          placeholder='1254232...'
          :disabled="disabled.candidateNumber"
          :error="formErrors.hasError('candidateNumber')"
          :error-messages="formErrors.fields.candidateNumber"
        )
      .d-flex.align-center
        filter-autocomplete(:getItems="getCBRUser" 
          item-value="ID" 
          item-text="username" 
          name="username"
          v-model="model.accountUsername"
          @input="valueUpdated"
          :disabled="true"
          label="CBR account"
        ).mr-4
        accept-activator(:model="model" :ID="model.ID")
        v-switch(v-model="model.keepAccepted" label="Keep accepted").ml-2

      filter-autocomplete(:getItems="getCBRStatus" 
        label="CBR status" 
        :disabled="disabled.cbrStatus"
        v-model="model.status")
      div
        filter-autocomplete(
          v-if="!isProductNameDisabled"
          :getItems="getProductNames" 
          v-model="model.productName"
          @input="valueUpdated"
          item-text="name"
          item-value="name"
          label="Product name"
          placeholder="Product name"
          :error="formErrors.hasError('productName')"
          :error-messages="formErrors.fields.productName"
        )
        v-text-field(
          v-else
          name="product"
          v-model="model.productName"
          placeholder="Product Name"
          disabled
        )
    
    v-col(cols=6)
      h3.form-title.pb-4 Contacts
      v-text-field(
        label="Email"
        v-model="model.candidateEmail" 
        @input="valueUpdated"
        :error="formErrors.hasError('candidateEmail')"
        :error-messages="formErrors.fields.candidateEmail"
      )
      
      v-text-field(label="Phone" v-model="model.candidateTel"
        @input="valueUpdated"
        :error="formErrors.hasError('candidateTel')"
        :error-messages="formErrors.fields.candidateTel"
      )
      v-text-field( v-model="model.address" label="Address" disabled)
      v-checkbox(
        v-model="model.are_dates_fixed"
        label="Fixed dates"
        hide-details
      )
      v-checkbox(
          hide-details
          v-model="model.unsubscribe_from_suggestions"
          label="Unsubscribe from suggestions"
        )
      

  h3.form-title Details
  courseChooseProvider(:item="model" @input:course="updateCourse")
    template(v-slot:default="courseChoose")
      v-row.item-container
        v-col(cols=6)
          v-text-field(label="Nickname" v-model="model.candidateName" @input="valueUpdated" data-test="c-edit-fullname")
        v-col(cols=6)
          v-text-field(
            label="Birthday" 
            name="bday"
            @input="valueUpdated"
            data-test="candidate-item-bday"
            v-model="model.candidateBirthday" 
            :disabled="disabled.candidateBirthday"
            :error="formErrors.hasError('candidateBirthday')"
            :error-messages="formErrors.fields.candidateBirthday"
          )
        v-col(cols=6)
          v-text-field(label="First name" 
            data-test="c-edit-first"
            @input="valueUpdated"
            v-model="model.firstName" 
            :error="formErrors.hasError('firstName')"
            :error-messages="formErrors.fields.firstName"
          )
        v-col(cols=6)
          filter-autocomplete(:getItems="getCRMCourseCities" 
            :value="model.course.city"
            @input="courseChoose.loadCoursesDatesByLocation"
            label="Course Location"
            item-value="ID" 
            item-text="name"
          )
        v-col(cols=6)
          v-text-field(
            data-test="c-edit-last"
            @input="valueUpdated"
            label="Last name" v-model="model.lastName"
            :error="formErrors.hasError('lastName')"
            :error-messages="formErrors.fields.lastName"
          )
        v-col(cols=6)
          v-select(
            :value="model.course.ID" 
            @input="model.course = $event"
            :loading="courseChoose.loading" 
            :disabled="!courseChoose.courses.length"
            :items="courseChoose.courses"
            item-text="dateAndName"
            item-value="ID"
            return-object
            :error="formErrors.hasError('courseDate')"
            :error-messages="formErrors.fields.courseDate"
            label="Course"
          )
        v-col(cols=6)
          v-text-field(v-model="model.drivingSchool" label="Driving school" disabled)

        v-col(cols=6)

        v-col(cols=6)
          field-date-picker(
            v-model="model.dateExercisesAccessExpires"
            label="Exercises access expires date"
            :min="currentDate"
            :hide-details="false"
          )
        v-col(cols=6)
          v-menu(
            :close-on-content-click="false"
            max-width="290px"
            min-width="290px"
            :disabled="!model.dateExercisesAccessExpires.length"
          )
            template(v-slot:activator="{ on, attrs }")
              v-text-field(:disabled="!model.dateExercisesAccessExpires.length" v-on="on" readonly v-model="model.timeExercisesAccessExpires" placeholder="Exercises access expires time")
            v-time-picker(format="24hr" v-model="model.timeExercisesAccessExpires")
        

  v-row.item-container
    v-col(cols=6)
      h3.form-title.pb-3 Reservation History
      history(:model="model" ref="tabs").item-container

    v-col(cols=6)
      h3.form-title.pb-3 Reservation details
      v-text-field(label="Reserved Location" hide-details :value="model.reservedExam.location" disabled )
      v-text-field(label="Reserved Date" hide-details :value="model.reservedExam.examDate" disabled)
      v-text-field(label="Reserved Code" hide-details :value="model.reservedExam.code" disabled )
  v-row.item-container
    v-col(cols=6)
      h3.form-title Exam Details
        
      //- course-location-filter(v-model="model.courseLocation")

</template>

<script>
import {mapActions} from "vuex"
import { convertToDefaultBackendFormat } from '@/util'
import DisabledFields from "../core/models/candidateDisabled.js"
import {CBR_STATUS_OPTIONS, CBR_STATUS, CANDIDATE_PAGE} from "../core/candidates-const"
import {PRODUCT_OPTIONS, PRODUCT} from "@/util/const"
import CandidateBroadcast from "../core/models/candidateBroadcast.js"

export default {
  props: {
    model: {
      type: Object,
      required: true
    },
    formErrors: Object,
    goBack: Function
  },

  data: () => ({
    CBR_STATUS,
    disabled: null,
    holdLoading: false,
    holdTitle: null,
    holdText: null,
    broadcast: null,
    productOptions: PRODUCT_OPTIONS,
    currentDate: convertToDefaultBackendFormat(new Date(Date.now())),
  }),

  computed: {
    disabledAddToLanding() {
      return this.model.status === CBR_STATUS.ARCHIVED
    },
    disabledParseNumberButton() {
      return this.model.status !== CBR_STATUS.RESERVED || (this.model.reservedExam.code && this.model.reservedExam.code.length > 0)
    },
    isProductNameDisabled() {
      return true
    },

    disabledReservationQueue() {
      if([CBR_STATUS.NEW, CBR_STATUS.ACCEPTED, CBR_STATUS.ARCHIVED, CBR_STATUS.RESERVED].includes(this.model.status)) return false
      return true
    },

    disabledCbrAccount() {
      if(this.disabled.cbrAccount) return true
      if(this.$route.name === this.$ROUTER_NAMES.CANDIDATES_TASKS) return true
      return false
    },

    disabledMarkAsProcessed() {
      if(this.hasReservedExam) return false
      if(this.$route.name === this.$ROUTER_NAMES.CANDIDATES_TASKS) return true
      return false
    },

    hasReservedExam () {
      return this.model.reservedExam.location ? true : false
    },

    isPageWithShowingWaitListBtn() {
      if(this.$route.name === this.$ROUTER_NAMES.CANDIDATES_RESERVE_EXCHANGE) return false
      if(this.$route.name === this.$ROUTER_NAMES.CANDIDATES_RESERVED_EXCHANGED) return false
      if(this.$route.name === this.$ROUTER_NAMES.COURSE_MANAGMENT) return false
      return true
    },

    canShowMijn() {
      if(([CBR_STATUS.NEW, CBR_STATUS.ARCHIVED].includes(this.model.status)) || this.model.isMijnReservation) return true
      return false
    },

    showLabels() {
      if(this.$route.name === this.$ROUTER_NAMES.COURSE_MANAGMENT) return false
      return true
    }
  },

  created() {
    this.initDisabled()
    this.initCandidateBroadcast()
  },

  methods: {
    initDisabled() {
      this.disabled = new DisabledFields()
    },
    async initCandidateBroadcast() {
      let tokens
      tokens = await this.$auth.getTokensFromRepoOrRefresh()
      this.broadcast = new CandidateBroadcast(this.disabled, tokens.access)
      this.broadcast.startListen(this.getBroadcastData, this.onReservedExamUpdate)
    },

    getBroadcastData() {
      return [this.model]
    },
    ...mapActions({
      getCBRUser: 'cbrUser/list',
      getCRMCourseCities: 'crmCourseCities/list',
      getProductNames: 'crmProductNames/list'
    }),

    getCBRStatus() {
      return CBR_STATUS_OPTIONS
    },


    checkReservationQueueHandler() {
      this.$emit('checkReservationClicked')
    },

    finishHoldEvent(val) {
      this.holdLoading = false
    },

    candidateNumberUpdating(val) {
      this.model.candidateNumber = val
      this.valueUpdated()
      this.$emit('candidateNumberChanged')
    },

    valueUpdated() {
      this.model.editing = true
    },

    onReservedExamUpdate(candidate) {
      if(candidate.reserved_exam) {
        this.$emit('reservedExam:update')
      } 
    },

    updateLabels(labels) {
      this.$emit('labelsChanged', labels)
    },

    updateCourse(course) {
      this.model.course = course
    }
  },

  components: {
    filterAutocomplete: () => import('@/components/global/FilterAutocomplete.vue'),
    holdSwitcher:() => import("./CandidateItemHoldSwitcher.vue"),
    markAsProcessed: () => import('./CandidateItemRemoveFromQueue.vue'),
    history: () => import('./CandidateItemTab.vue'),
    waitListBtn: () => import('./item/CandidatesWaitBtn.vue'),
    acceptActivator: () => import('./CandidateAcceptActivator.vue'),
    setMijn: () => import('./CandidatesSetMijn.vue'),
    labels: () => import('./CandidatesCustomLabels.vue'),
    courseChooseProvider: () => import('./reservation/CandidateCourseChooseProvider.vue'),
    removeFromAccept: () => import('./CandidateItemRFA.vue'),
    candidateArchive: () => import('./CandidatesArchive.vue'),
    acceptTest: () => import('./CandidatesAcceptTest.vue'),
    removeMIJN: () => import('./item/CandidateRemoveMijn.vue'),
    sync: () => import('./CandidatesSync.vue'),
    addToLanding: () => import('./CandidatesAddToLanding.vue'),
    fieldDatePicker: () => import('@/components/global/FieldDatepicker.vue')

  }
}
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity 2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>

<style lang="scss" scoped>
.top-fields {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  &__item {
    margin-right: 8px;
    margin-top: 8px;
  }
}
</style>